// =============================================================================
// services/app-config.ts — static app constants + version reads (bare-RN).
//
// Blueprint §1 / #9: the bare-RN replacement for the bits of `expo-constants` the
// services + screens actually read:
//   - app version / build number  → react-native-device-info (DeviceInfo.*)
//   - the WalletConnect project id → a hardcoded public constant (it was only a
//     build-time `extra` value; it is a PUBLIC id, safe to inline)
//   - the EAS push projectId        → DROPS OUT entirely (only Expo Push needed it;
//     push moves off Expo in P4, so there is nothing to surface here).
//
// Centralizing these here means screens (settings) read one stable module
// instead of poking `Constants.expoConfig` shapes.
// =============================================================================
import DeviceInfo from 'react-native-device-info';

// Marketing version string (CFBundleShortVersionString), e.g. "1.3.1".
// Mirrors the old `Constants.expoConfig?.version`.
export function getAppVersion(): string {
  try {
    return DeviceInfo.getVersion();
  } catch {
    return '1.3.1';
  }
}

// Build number (CFBundleVersion / iOS buildNumber), e.g. "61".
// Mirrors the old `Constants.expoConfig?.ios?.buildNumber`.
export function getBuildNumber(): string {
  try {
    return DeviceInfo.getBuildNumber();
  } catch {
    return '';
  }
}

// Convenience "1.3.1 (61)" string for the settings "About" row.
export function getVersionDisplay(): string {
  const v = getAppVersion();
  const b = getBuildNumber();
  return b ? `${v} (${b})` : v;
}

// WalletConnect Cloud project id — a PUBLIC id (safe to ship in the client). Was
// `Constants.expoConfig?.extra?.walletConnectProjectId` with this exact fallback.
// Currently UNUSED in v1 (the wallet stack was removed while crypto is gated OFF);
// kept here so the wallet config can be re-wired verbatim when crypto un-gates.
export const WALLET_CONNECT_PROJECT_ID = 'f37dc106dfe9a7ebaf50bc9fb499572d';
